// Core i18next library.
import i18n from "i18next";
// Bindings for React: allow components to
// re-render when language changes.
import { initReactI18next } from "react-i18next";
import HttpApi from "i18next-http-backend";

i18n
  // Add React bindings as a plugin.
  .use(HttpApi)
  .use(initReactI18next)
  // Initialize the i18next instance.
  .init({             
    lng: "it",
    fallbackLng: "en",
    debug: true,
    interpolation: {
      escapeValue: false,
    },


  });

export default i18n;